import pdfIcon from 'assets/images/jpg/pdf-icon.jpg';
import imageIcon from 'assets/images/png/image-icon.png';
import jpgIcon from 'assets/images/png/jpg-icon.png';
import pngIcon from 'assets/images/png/png-icon.png';
import { getStringOrThrow } from 'typeGuards/typeGuards';

export function getIconFromImageName(imageName: string): string {
  const imageExtension = imageName.split('.').pop()?.toLowerCase();

  switch (imageExtension) {
    case 'pdf':
      return getStringOrThrow(pdfIcon);
    case 'png':
      return getStringOrThrow(pngIcon);
    case 'jpg':
    case 'jpeg':
      return getStringOrThrow(jpgIcon);
    default:
      return getStringOrThrow(imageIcon);
  }
}
